<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S129G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_18 col_31'><span class='brt high default' id='text3'>PRINT  INFORMATION</span>  </div>
  <div class='lgr_20 col_59'><dynamic-field [id]='"revnbr"' [size]=20 [line]=2 [column]=59 [(ngModel)]='revnbr'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_36 col_01'><span class='brt high default' id='text4'>CONTROL/BOOK #  CONJ  PRINT    PRINT</span>  </div>
  <div class='lgr_39 col_40'><span class='brt high default' id='text5'>OUT  SRC  LOC  AGENT   PRINTER  SUBTYPE</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_36 col_01'><span class='brt high default' id='text6'>CONVERTED TKT#        DATE     TIME </span>  </div>
  <div class='lgr_39 col_40'><span class='brt high default' id='text7'>                       ID       CODE   </span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup1"' [size]=79 [line]=7 [column]=1 [(ngModel)]='coup1'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup2"' [size]=79 [line]=8 [column]=1 [(ngModel)]='coup2'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup3"' [size]=79 [line]=10 [column]=1 [(ngModel)]='coup3'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup4"' [size]=79 [line]=11 [column]=1 [(ngModel)]='coup4'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup5"' [size]=79 [line]=13 [column]=1 [(ngModel)]='coup5'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup6"' [size]=79 [line]=14 [column]=1 [(ngModel)]='coup6'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup7"' [size]=79 [line]=16 [column]=1 [(ngModel)]='coup7'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup8"' [size]=79 [line]=17 [column]=1 [(ngModel)]='coup8'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=21 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text8'>PF:</span>  </div>
  <div class='lgr_06 col_12'><span class='brt high default' id='text9'>4-EXIT</span>  </div>
  <div class='lgr_06 col_19'><span class='brt high default' id='text10'>3-MAIN</span>  </div>
  <div class='lgr_05 col_26'><dynamic-field [id]='"selmen"' [size]=5 [line]=23 [column]=26 [(ngModel)]='selmen'></dynamic-field></div>
  <div class='lgr_05 col_32'><dynamic-field [id]='"iss"' [size]=5 [line]=23 [column]=32 [(ngModel)]='iss'></dynamic-field></div>
  <div class='lgr_06 col_38'><dynamic-field [id]='"prev"' [size]=6 [line]=23 [column]=38 [(ngModel)]='prev'></dynamic-field></div>
  <div class='lgr_06 col_45'><dynamic-field [id]='"next"' [size]=6 [line]=23 [column]=45 [(ngModel)]='next'></dynamic-field></div>
  <div class='lgr_08 col_52'><dynamic-field [id]='"coupon"' [size]=8 [line]=23 [column]=52 [(ngModel)]='coupon'></dynamic-field></div>
  <div class='lgr_08 col_62'><dynamic-field [id]='"usage"' [size]=8 [line]=23 [column]=62 [(ngModel)]='usage'></dynamic-field></div>
  <div class='lgr_08 col_72'><span class='brt high default' id='text11'>12-PRINT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text12'>SHIFT PF:</span>  </div>
  <div class='lgr_12 col_11'><dynamic-field [id]='"currc1"' [size]=12 [line]=24 [column]=11 [(ngModel)]='currc1'></dynamic-field></div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
  <div class='lgr_09 col_44'><dynamic-field [id]='"paymt"' [size]=9 [line]=24 [column]=44 [(ngModel)]='paymt'></dynamic-field></div>
  <div class='lgr_08 col_55'><dynamic-field [id]='"last"' [size]=8 [line]=24 [column]=55 [(ngModel)]='last'></dynamic-field></div>
  <div class='lgr_09 col_65'><dynamic-field [id]='"first"' [size]=9 [line]=24 [column]=65 [(ngModel)]='first'></dynamic-field></div>
</div>
</div>
